import { ActionType } from "actions/ActionType";

export const toggleDarkMode = () => ({ type: ActionType.TOGGLE_DARK_MODE });
